import React from 'react';
import { CountdownProvider } from '../contexts/CountdownContext';
import { UrgencyBar } from '../components/UrgencyBar';
import { AttentionHero } from '../components/AttentionHero';
import { VideoSection } from '../components/VideoSection';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Benefits } from '../components/Benefits';
import { Offer } from '../components/Offer';
import { Testimonials } from '../components/Testimonials';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <CountdownProvider data-id="element-226" data-mp="1ouzgi1cxfxku">
      <div className="w-full bg-cream font-sans text-charcoal" data-id="element-227" data-mp="1tvn8oqcw6kgn">
        <UrgencyBar data-id="element-228" data-mp="1ttu73ph4yqfi" />
        <main data-id="element-229" data-mp="3qo6wld0d6j7s">
          <AttentionHero data-id="element-230" data-mp="3qoqbekupwrhl" />
          <VideoSection data-id="element-231" data-mp="3qpi85z01wv9g" />
          <Hero data-id="element-232" data-mp="3qq9tmgzxpcm0" />
          <PainPoints data-id="element-233" data-mp="3qqjhnz1f59p2" />
          <Benefits data-id="element-234" data-mp="3vmrwfbbpf0vp" />
          <Offer data-id="element-235" data-mp="3vobaqwdsv1uu" />
          <Testimonials data-id="element-236" data-mp="3vntgg5ap6xpk" />
          <Faq data-id="element-237" data-mp="3vp4l07byw9hq" />
          <FinalCta data-id="element-238" data-mp="3ajgh4xknrlxy" />
        </main>
        <Footer data-id="element-239" data-mp="3akrspjkchxzm" />
      </div>
    </CountdownProvider>;
}